import React, { useEffect, useState } from "react";
import { adminStats, formatRON } from "@/lib/api";

const Card = ({ label, value }) => (
  <div className="border border-border p-6">
    <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{label}</div>
    <div className="mt-2 text-3xl font-black">{value}</div>
  </div>
);

const StatsAdmin = () => {
  const [s, setS] = useState(null);
  useEffect(() => { adminStats().then(setS).catch(() => {}); }, []);
  if (!s) return <div className="p-8 font-mono text-xs uppercase tracking-widest text-muted-foreground">…</div>;
  return (
    <div className="p-5 sm:p-8" data-testid="stats-admin">
      <h2 className="mb-6 text-xl uc font-semibold">Statistici</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <Card label="Comenzi" value={s.orders_count} />
        <Card label="Venit total" value={formatRON(s.revenue)} />
        <Card label="Produse" value={s.products_count} />
      </div>
      <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div>
          <h3 className="mb-3 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">Cele mai vândute</h3>
          <div className="divide-y divide-border border-y border-border">
            {s.top_products.map((t) => <div key={t.name} className="flex justify-between py-2 font-mono text-xs uppercase"><span>{t.name}</span><span>{t.qty}</span></div>)}
            {s.top_products.length === 0 && <p className="py-3 font-mono text-xs uppercase tracking-widest text-muted-foreground">—</p>}
          </div>
        </div>
        <div>
          <h3 className="mb-3 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">Stoc scăzut (≤3)</h3>
          <div className="divide-y divide-border border-y border-border">
            {s.low_stock.map((l, i) => <div key={i} className="flex justify-between py-2 font-mono text-xs uppercase"><span>{l.name} · {l.size}</span><span className={l.stock === 0 ? "text-destructive" : ""}>{l.stock}</span></div>)}
            {s.low_stock.length === 0 && <p className="py-3 font-mono text-xs uppercase tracking-widest text-muted-foreground">—</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsAdmin;
